import { useEffect, useState } from 'react';
// @mui
import {
  Box,
  Button,
  LinearProgress,
  Typography,
  Select,
  Stack,
  CardContent,
  Card,
  Container,
  Divider,
  styled,
  Tab,
} from '@mui/material';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import moment from 'moment';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import useTable from '../../hooks/useTable';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { TableSkeleton } from '../../components/table';

import conObj from '../../utils/connection-assistant';
import CustomDateRangePicker from '../../components/CustomDateRangePicker';
import useLocales from '../../hooks/useLocales';
import { useSelector } from '../../redux/store';

import { fDate } from '../../utils/formatTime';
import { fCurrency } from '../../utils/formatNumber';
import getPercentage from '../../utils/getPercentage';
import SvgIconStyle from '../../components/SvgIconStyle';
import Iconify from '../../components/Iconify';
import TransactionHistory from './TransactionHistory';
import GameHistory from './GameHistory';

const StyledTabList = styled(TabList)(({ theme }) => ({
  //   background: palette.transactionDialog.deposit.tabBg,
  // borderBottom: '1px solid #FF0000',
  minHeight: 'unset',
  padding: 12,
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
}));

const StyledTab = styled(Tab)(() => ({
  height: 30,
  borderRadius: 20,
  minHeight: 'unset',
  padding: 4,
  fontSize: '.875rem',
  fontWeight: 700,
  display: 'flex',
  flex: 1,
  margin: '0 !important',
}));

const History = () => {
  const { translate } = useLocales();

  const [activeTab, setActiveTab] = useState('TRANSACTION');

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Page title="History">
      <Box sx={{ background: '#000' }}>
        <TabContext value={activeTab}>
          <StyledTabList
            onChange={handleChange}
            TabIndicatorProps={{
              style: { display: 'none' },
            }}
          >
            <StyledTab
              label={translate('transaction_history')}
              value="TRANSACTION"
              sx={{
                width: '100%',
                background: activeTab === 'TRANSACTION' ? '#EE0000' : 'transparent',
              }}
            />
            <StyledTab
              label={translate('game_history')}
              value="GAME_HISTORY"
              sx={{
                background: activeTab === 'GAME_HISTORY' ? '#EE0000' : 'transparent',
              }}
            />
          </StyledTabList>
          <Divider orientation="horizontal" flexItem />
          <TabPanel value="TRANSACTION">
            <TransactionHistory />
          </TabPanel>
          <TabPanel value="GAME_HISTORY">
            <GameHistory />
          </TabPanel>
        </TabContext>
      </Box>
    </Page>
  );
};

export default History;
